import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import smh from '@/renderer/scripts/smh';
import store from '@/renderer/store';
import user from '@/renderer/scripts/utils/user';

/**
 * 检查 role 是否是管理员
 * role: 'admin' | 'superAdmin' | 'teamAdmin' | 'user'
 * excludeTeamAdmin: 管理员身份是否包含团队管理员
 */
export const checkRoleIsAdmin = (role: string, excludeTeamAdmin?: boolean): boolean => {
  const arr = ['admin', 'superAdmin'];
  if (!excludeTeamAdmin) {
    arr.push('teamAdmin');
  }
  return arr.includes(role);
};
export const getUserRole = async (): Promise<RoleMap> => {
  const { userId } = user.getUserInfo();
  const { data } = await smh.userAPI.getUser({
    userId,
  });
  const { role, canManageTeams } = data;
  if (checkRoleIsAdmin(role, true)) {
    return {
      admin: RoleMap.Admin,
      superAdmin: RoleMap.SuperAdmin,
    }[role as 'admin' | 'superAdmin'];
  }
  if (canManageTeams?.length) {
    return RoleMap.TeamAdmin;
  }
  return RoleMap.User;
};
export const getCheckManagementPermission = async (): Promise<0 | 1> => {
  const userRole = store.getters.userRole || (await getUserRole());
  const isAdminOrSuperAdmin = userRole === RoleMap.Admin || userRole === RoleMap.SuperAdmin;
  if (isAdminOrSuperAdmin) return 0;
  return 1;
};
export const getOrgEdition = (): string => {
  const { editionFlag } = user.getUserInfo();
  return editionFlag as string;
};
